import assest from "@/json/assest";
import {
  Box,
  MenuItem,
  Select,
  SelectChangeEvent,
  styled,
} from "@mui/material";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { number } from "yup/lib/locale";
import { useRouter } from "next/router";

const SearchHeaderWrapper = styled(Box)`
  .title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 0 16px;
    flex-wrap: wrap;
    h4 {
      font-weight: 600;
      font-size: 16px;
      color: #121d32;
      margin: 0;
      @media (max-width: 575px) {
        margin: 0 0 10px;
      }
    }
    p {
      font-weight: 400;
      font-size: 14px;
      line-height: 1.6;
      color: #8d99ae;
      margin: 10px 0 0;
    }
    .dashboardSearchFilter {
      display: flex;
      max-width: 408px;
      flex-basis: 408px;
      justify-content: flex-end;
      @media (max-width: 1199px) {
        flex-wrap: wrap;
        max-width: 100%;
        flex-basis: 100%;
      }
    }
    .dashboardSearch {
      max-width: calc(100% - 142px);
      flex-basis: calc(100% - 142px);
      position: relative;
      @media (max-width: 1199px) {
        max-width: 100%;
        flex-basis: 100%;
      }
      button {
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translate(0, -50%);
        background: transparent;
        border: none;
      }
    }
    .dashboardFilter {
      max-width: 132px;
      flex-basis: 132px;
      margin: 0 0 0 20px;
      position: relative;

      @media (max-width: 1199px) {
        max-width: 100%;
        flex-basis: 100%;
        margin-top: 10px;
        margin-left: 0;
      }
      &.newfilter_gap {
        .MuiInputBase-root.css-ou77eo-MuiInputBase-root-MuiOutlinedInput-root-MuiSelect-root {
          min-width: inherit;
        }
      }
      @media (max-width: 575px) {
        margin: 10px 0 0 0px;
        max-width: 100%;
        flex-basis: 100%;
      }
      .MuiInputBase-root {
        min-width: 120px;
        width: 100%;
        @media (max-width: 575px) {
          width: 100%;
        }
      }
      .MuiOutlinedInput-input {
        padding: 13px 10px;
        padding-right: 28px;
      }
      select {
        font-weight: 400;
        font-size: 14px;
        color: #121d32;
      }
      .dashboardSelect {
        .MuiMenu-list {
          padding: 0;
        }
      }
    }
  }
  &.search-wrapDashbrd {
    margin: 0px 15px 0 auto;
    @media (max-width: 991px) {
      margin-left: 0;
    }
    .title {
      margin-bottom: 0 !important;
      .dashboardSearchFilter {
        width: 100%;
        flex-basis: 325px;
        min-width: 325px;
        @media (max-width: 991px) {
          flex-basis: 200px;
          min-width: 200px;
        }
        .dashboardSearch {
          width: 100%;
          max-width: 100%;
          flex-basis: 100%;
          input {
            background: url("/assets/images/serchicon31.svg") no-repeat center
              left 10px;
            padding-left: 32px;
          }
        }
      }
    }
  }
`;

interface SearchHeaderprops {
  name: string;
  text: string;
  options: any[] | any;
  search: string;
  value: string;
  status: string | number;
  type: string;
  onChange: any;
  clear_search: any;
  selectedOption: string | number;
  className?: string;
  handleSelectedOption: (e: SelectChangeEvent) => void;
  handleSelectedOptionClient: (e: SelectChangeEvent) => void;
  handleSelectedOptionProvider: (e: SelectChangeEvent) => void;
  hideSearchbar?: boolean;
}

const SearchHeader = ({
  name,
  text,
  search,
  value,
  status,
  onChange,
  options,
  clear_search,
  type,
  className,
  selectedOption,
  handleSelectedOption,
  handleSelectedOptionClient,
  handleSelectedOptionProvider,
  hideSearchbar,
}: SearchHeaderprops) => {
  const [open, setOpen] = useState(false);
  //console.log("value", value);

  const handleTogle = () => setOpen(!open);

  useEffect(() => {
    if (
      type === "projects" ||
      type === "manageClientSearch" ||
      type === "transacton"
    ) {
      clear_search("");
    }
    // else if (type="manageClientSearch"){
    //   clear_search("");
    // }
    // else if (type="transacton"){
    //   clear_search("");
    // }
  }, [status, type]);

  const router = useRouter();

  return (
    <SearchHeaderWrapper className={`${className}`}>
      <Box>
        <Box className="title">
          <Box>
            <h4>{name}</h4>
            <p>{text}</p>
          </Box>
          <Box className="dashboardSearchFilter">
            {!hideSearchbar && (
              <Box className="dashboardSearch">
                <input
                  type="text"
                  name={name}
                  placeholder={
                    `${
                      router.pathname ===
                      "/support-ticket/support-category-ticket search"
                    }`
                      ? "Search by Name or Phone"
                      : "search"
                  }
                  value={search}
                  onChange={onChange}
                />
                {/* <button>
                <Image src={assest.searchGray} width={16} height={16} alt="" />
              </button> */}
              </Box>
            )}

            {name === "Projects" && (
              <Box className="dashboardFilter">
                <Select
                  displayEmpty
                  value={selectedOption}
                  open={open}
                  // className="check"
                  onClose={handleTogle}
                  onClick={handleTogle}
                  onChange={
                    handleSelectedOptionClient || handleSelectedOptionProvider
                  }
                  defaultValue=""
                >
                  <MenuItem value={""} disabled>
                    Filter
                  </MenuItem>
                  {options?.map((item) => (
                    <MenuItem value={item?.value}>{item?.name}</MenuItem>
                  ))}
                </Select>
              </Box>
            )}

            {name === "Partners & Sponsors" && (
              <Box className="dashboardFilter newfilter_gap">
                <Select
                  displayEmpty
                  value={selectedOption}
                  open={open}
                  // className="check"
                  onClose={handleTogle}
                  onClick={handleTogle}
                  onChange={handleSelectedOption}
                  defaultValue=""
                >
                  <MenuItem value={""} disabled>
                    Filter
                  </MenuItem>
                  {options?.map((item) => (
                    <MenuItem value={item?.value}>{item?.name}</MenuItem>
                  ))}
                </Select>
              </Box>
            )}

            {/* <Box className="dashboardFilter">
              <Select
                displayEmpty
                value={selectedOption}
                open={open}
                // className="check"
                onClose={handleTogle}
                onClick={handleTogle}
                onChange={handleSelectedOption}
                
              >
                {options?.map((item) => (
                  <MenuItem value={item?.value}>{item?.name}</MenuItem>
                ))}
              </Select>
            </Box> */}
          </Box>
        </Box>
      </Box>
    </SearchHeaderWrapper>
  );
};

export default SearchHeader;
